export default {
  projectNumber: '项目编号',
  projectName: '项目名称',
  bindEnvAndSceneRelation: '绑定环境和场景关系',
  customer: '客户名称',
  industry: '所属行业',
  sales: '销售',
  presales: '售前',
  postsales: '售后',
  createUserName: '创建用户',
  pocState: '当前状态',
  projectType: '预测类型',
  enablePC: '是否利旧PC项目',
  enableProduct: '是否投入实际生产环境进行试用',
  professionalWinningProject: '是否专业致胜专项',
  crmOrderId: 'CRM业务单号',
  projectArea: '区域&部门',
  postsalesLeaderIds: '售后主管',
  extensionIds: '拓展',
  requestConfirm: '方案差异',
  requestConfirmContent: '方案差异说明',
  projectBackground: '背景说明',
  projectRequest: '核心需求',
  testCycle: '测试周期(天)',
  testMode: '测试模式',
  competitor: '友商PK',
  otherCompetitor: '其他友商',
  startTime: '项目启动时间',
  createTime: '创建时间',
  updateTime: '最新更新时间',
  projectPlan: '项目方案',
  addBind: '添加绑定',
  envCollectSearchField: '客户/客户岗位/联系人',
  industryEmpty: '请选择所属行业',
  customerEmpty: '客户名称',
  salesEmpty: '请选择销售人员',
  presalesEmpty: '请选择售前人员',
  postsalesEmpty: '请选择售后人员',
  postsalesLeaderEmpty: '请选择售后主管',
  extensionEmpty: '请选择拓展人员',
  projectAreaEmpty: '请选择区域',
  projectTypeEmpty: '预测类型',
  testCycleEmpty: '测试周期，单位:天',
  testModeEmpty: '测试模式，支持多选',
  competitorEmpty: '友商列表',
  startTimeEmpty: '启动时间',
  otherCompetitorPlaceholder: '补充其他友商，允许为空',
  editProject: '编辑项目',
  uploadCollectReport: '上传采集报告',
  envCollectReport: '环境采集报告',
  envCollectReportNotEmpty: '采集报告不能为空',
  searchPlaceholder: '客户名称/项目名称/项目创建用户',
  searchReportPlaceholder: '项目客户/名称/软件版本/外设类型/创建人',
  searchCompatiblePlaceholder: '产品版本/操作系统/上报人',
  dataState: '数据状态',
  functionView: '功能详情',
  projectSourceType: '项目来源',
  btns: {
    showDetail: '查看',
    setTemplate: '设为模版',
    copy: '复制',
    requestConfirm: '方案确认',
    deal: '处理',
    edit: '修改',
    cancel: '关闭',
    confirm: '确认',
    createPocProject: '全新创建',
    createProjectFromTemplate: '模板创建',
    detail: '详情'
  },
  case: '场景说明',
  createBasePocProject: '售前测试项目基础信息',
  createPocProjectForm: {},
  collectPocDialog: {
    createBaseProject: '快速创建项目',
    createBaseProjectDesc: '没有提前采集客户环境信息，只需填写项目的基本信息的，请选择此入口',
    createDetailProject: '高级创建项目',
    createDetailProjectDesc: '采集客户环境信息，并与业务场景进行绑定；有提前采集客户环境信息的，请选择此入口'
  },
  functionList: {
    featureName: '功能名称',
    type: '功能类型',
    length: '优劣势',
    valueDesc: '价值',
    handelAction: '操作',
    sceneName: '场景',
    resolveIssues: '解决客户问题',
    limitDesc: '相关限制说明',
    productVersion: '产品版本',
    expectedOutcome: 'xxxx',
    competitiveComparison: 'xxx',
    video: '演示视频',
    ppt: '演示PPT',
    userRole: '使用者角色',
    desktopArch: '桌面架构'
  },
  client: {
    type: '客户端类型',
    series: '系列',
    version: '型号',
    brand: '品牌',
    cpu: 'CPU',
    memory: '内存信息(G)',
    disk: '硬盘信息(G)',
    diskNum: '硬盘数量',
    gpu: '显卡',
    enableUEFI: '是否支持UEFI',
    remarks: '使用说明'
  },
  spec: {
    specName: '负载选择',
    desktopNum: '终端 (桌面) 数量'
  },
  server: {
    serverName: '服务器型号',
    cpu: 'CPU(线程数)',
    cpuTotalThreads: 'CPU线程数',
    memory: '内存(G)',
    nicsInfo: '网卡信息',
    diskInfo: '磁盘大小(G)'
  },
  peripheral: {
    name: '外设名称',
    type: '设备类型',
    manufacturer: '品牌厂商',
    interfaceType: '接口类型',
    hardwareCode: '硬件编码',
    hasCompatible: '是否兼容',
    compatibleDesc: '兼容说明',
    source: '来源'
  },
  soft: {
    softwareName: '软件名称',
    softwareVersion: '软件版本',
    publisher: '发布者',
    compatibleDesc: '兼容说明',
    hasCompatible: '是否兼容',
    requirement: '特殊要求',
    purpose: '用途/地址',
    archType: '软件架构',
    sourceType: '来源'
  },
  tips: {
    createPreTestingProjectType: 'xxx',
    enablePC: '如有客户PC需要利旧的场景，需要在后面收集利旧PC的信息',
    deletePocProject: '删除项目【{customer}】吗？',
    deleteTemplateProject: '删除模版项目【{customer}】吗？',
    setPocProjectTemplate: '设置项目【{customer}】为模版吗？',
    createPocProject: '创建售前测试项目',
    createProjectFromTemplate: '根据模板创建售前测试项目',
    createPocProjectType: '请选择售前测试项目的收集数据类型',
    projectRequest: '影响本次测试效果，客户必须要解决的问题'
  },
  question: {
    peripheral:
      '1、本栏目显示客户环境采集的外设信息（包括型号、接口及对应业务场景）\r\n2、如果外设已在云桌面产品上做过兼容测试，会打上兼容标签\r\n3、所有外设默认选中，并输出到测试方案进行测试，也可以点击取消选中不进行售前测试\r\n4、可以通过 + 号进行额外添加外设进行补充用例测试'
  },
  collectImport: '使用客户环境采集工具导出的报告(zip)进行导入'
}
